module.exports = __webpack_public_path__ + "img/pres-02.715f5203.png";